<template>
  <v-flex
     xs12
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <AutoComplete
        v-model="searchSchool"
        :value="searchSchool"
        key-value="id"
        key-name="fullname"
        enable-chips
        enable-clearable
        enable-autofocus
        :items="schools"
        :label="$t('fields.school')"
        @search="searchSchools"
        @input="fetchSchoolsIfExist"
        @clear="deleteSelectedSchools"
        :delay="2000"
        :errors="errors"
        :key="reloadAutocomplete"
        :disabled="loading"
      >
      </AutoComplete>
      </v-flex>
      <v-flex xs3 class="mr-2 mt-3">
      <v-select
        :items="codes"
        v-model="schoolCodeId"
        item-text="name"
        item-value="id"
        :label="$t('fields.code')"
        :error-messages="errors"
        @change="fetchTeachers"
        :disabled="!codes.length"
        multiple
      >
      </v-select>
      </v-flex>

      <v-flex xs3 class="mr-2 mt-3">
      <v-select
        :items="subjects"
        v-model="subjectId"
        item-text="name"
        item-value="id"
        :label="$t('fields.subject')"
        :error-messages="errors"
        @change="fetchTeachers"
        :disabled="!subjects.length"
        multiple
      >
      </v-select>
      </v-flex>

      <v-flex xs2 class="mr-2 mt-3">
      <Search
          :disabled="!subjects.length"
          v-model="filters.years"
          :label="$t('fields.year')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
      <v-flex>
        <v-btn
          :disabled="!isSchoolSelected"
          :to="{path: `/schools/${isSchoolSelected}/grid`}"
        >
          {{ $t('EDIT_GRID') }}
        </v-btn>

        <v-btn
          :disabled="!isSchoolSelected || loadingPdf"
          @click="generatePdf()"
          class="ml-2"
        >
          {{ $t('PRINT') }}
        </v-btn>

      </v-flex>
    <v-row>
    </v-row>
    </v-container>
    <v-row>
      <ListHorizontal :data="prepareSchoolsInfo()"></ListHorizontal>
    </v-row>
    <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="totalItems"
            :no-data-text="$t('NO_DATA')"
            :no-results-text="$t('NO_DATA')"
            hide-default-footer
            :options.sync="pagination"
            must-sort
            :loading="loading"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            item-key="id"
            show-expand
            class="elevation-1"
            :item-class="itemRowBackground"
          >
            <template v-slot:[`item.teacher_fullname`]="{ item }">
                  {{ item.teacher.fullname }}
            </template>

            <template v-slot:[`item.school_name`]="{ item }">
                  {{ item.school.name }}
            </template>

            <template v-slot:[`item.subject_name`]="{ item }">
                  {{ item.subject.name }}
            </template>

            <template v-slot:[`item.books_counter`]="{ item }">
                <v-badge v-if="item.campaign.counter" :content="item.campaign.counter"></v-badge>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                  <v-layout row wrap>
                    <v-flex>
                        <v-btn
                          icon
                          :color="item.school.counter > 1 ? 'white' : 'blue'"
                          v-if="can('edit teachers')"
                          :disabled="!currentUser.user.is_propagandist"
                         @click="showCampaignModal(item.teacher.id)"
                        >
                          <v-icon>menu_book</v-icon>
                        </v-btn>
                    </v-flex>
                  </v-layout>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <CampaignTeacherDetailTable
                  :teacher-id="item.teacher.id"
                  :years="filters.years"
                >
                </CampaignTeacherDetailTable>
              </td>
            </template>
          </v-data-table>
          <Paginator
            :total-items="totalItems"
            :page.sync="pagination.page"
            :items-per-page.sync="pagination.itemsPerPage"
            :per-page-options="[10, 20, 40, 60, 100, 150, 200]"
            @change="fetchTeachers"
          />
  </div>
  </v-flex>
</template>
<script>

  import { mapActions, mapGetters } from 'vuex';

  import { campaignsService } from '../../utils/services/campaigns.service';
  import { schoolsService } from '../../utils/services/schools.service';
  import AutoComplete from '../../components/shared/Inputs/AutoComplete';
  import ListHorizontal from '../../components/shared/Lists/ListHorizontal';
  import CampaignTeacherModal from '../../components/modals/Campaigns/CampaignTeacherModal';
  import MessageModal from '../../components/modals/shared/MessageModal.vue';
  import CampaignTeacherDetailTable from '../../components/app/Campaigns/CampaignTeacherDetailTable';
  import { schoolsCodesService } from '../../utils/services/schoolsCodes.service';
  import Search from '../../components/shared/Inputs/Search';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'CampaignSchoolResult',
    components: { AutoComplete, ListHorizontal, CampaignTeacherDetailTable, Search, Paginator },
    data() {
      return {
        loading: false,
        loadingPdf: false,
        expanded: [],
        singleExpand: true,
        items: [],
        schools: [],
        codes: [],
        subjects: [],
        totalItems: 0,
        searchSchool: null,
        schoolCodeId: [],
        subjectId: [],
        school: {},
        reloadAutocomplete: false,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['teacher_fullname'],
        },
        headers: [
          { text: this.$t('fields.teacher'), value: 'teacher_fullname' },
          { text: this.$t('fields.school'), value: 'school_name' },
          { text: this.$t('fields.subject'), value: 'subject_name' },
          { text: this.$t('fields.book'), value: 'books_counter' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
          { text: '', value: 'data-table-expand', sortable: false },
        ],
        filters: {
          searchSchools: null,
          schoolId: 0,
          years: null,
        },
      };
    },
    computed: {
      ...mapGetters('user', ['currentUser']),
      requestFilters() {
        const filters = {
          schoolCodeId: this.schoolCodeId,
          subjectId: this.subjectId,
          years: this.filters.years,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

      isSchoolSelected() {
        return this.filters.schoolId;
      },

    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      itemRowBackground(item) {
        return item.school.counter > 1 ? 'blue' : '';
      },

      /**
       * Reload the first page when the user changes column or direction.
       * Sorting is server side, so both sortBy and sortDesc must trigger it.
       */
      refetchOnSortChange(newVal, oldVal) {
        if (!this.filters.schoolId) {
          return;
        }
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
          return;
        }
        this.fetchTeachers(1);
      },

      generatePdf() {
          this.loadingPdf = true;
          this.showLoadingMessage();
          return schoolsService.generatePdf(this.isSchoolSelected, {
            filters: this.requestFilters,
          })
          .then((response) => {
            response.data.files.forEach((fileToDownload) => {
              const linkSource = `data:application/pdf;base64,${fileToDownload.file}`;
              const downloadLink = document.createElement('a');
              const fileName = fileToDownload.name;
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.target = '_blank';
              if (document.createEvent) {
                  const event = document.createEvent('MouseEvents');
                  event.initEvent('click', true, true);
                  downloadLink.dispatchEvent(event);
              } else {
                  downloadLink.click();
              }
            });
          }).catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loadingPdf = false;
            this.hideModal({});
          });
      },

      async showLoadingMessage() {
        this.showModal({
          component: MessageModal,
            data: {
              stored: {
                title: 'Caricamento in corso',
                message: "L'operazione potrebbe richiedere qualche minuto. Attendere...",
              },
          },
        });
      },

      async showCampaignModal(id) {
        this.showModal({
          component: CampaignTeacherModal,
            data: {
              stored: {
                id,
                teacher_id: this.filters.teacherId || id,
              },
          },
          options: {
            title: this.$t('CAMPAIGN'),
            fullscreen: true,
            onSave: (
              form,
              error,
            ) => campaignsService.save(form)
            .then(() => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchBooks(this.pagination.page);
            }),
          },
        });
      },

      deleteSelectedSchools() {
        this.codes = [];
        this.school = {};
        this.subjects = [];
        this.shools = [];
        this.reloadAutocomplete = !this.reloadAutocomplete;
      },

      fetchCodes(schoolId) {
        return schoolsCodesService.index(schoolId)
        .then(response => {
            this.codes = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchSubjects(schoolId) {
        return schoolsService.subjects(schoolId)
        .then(response => {
            this.subjects = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      searchSchools(val) {
        this.filters.searchSchools = val;
        this.fetchSchools();
      },

      async fetchSchools() {
        this.loading = true;
        return schoolsService.index({
          filters: {
            search: this.filters.searchSchools,
          },
        })
        .then(response => {
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchTeachers(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return schoolsService.teachers(this.filters.schoolId, {
          page: forcePage || page || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async fetchSchoolsIfExist(id) {
        if (id > 0) {
          this.filters.schoolId = id;
          await this.fetchSchool(id);
          await this.fetchCodes(id);
          await this.fetchSubjects(id);
        } else {
          this.filters.schoolId = 0;
        }
        this.shools = [];
      },

      async fetchSchool(id) {
        this.loading = true;
        return schoolsService.get(id)
        .then(response => {
            this.school = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      prepareSchoolsInfo() {
        let schoolInfo = [];
        if (Object.keys(this.school).length) {
          // const address = this.school.addresses.filter(x => JSON.parse(x.options).is_default)[0];

          schoolInfo = [
            /*
            { value: this.teacher.surname },
            { value: this.teacher.name },
            { value: address.email },
            { value: address.phone },
            { value: address.street },
            */
          ];
        }
        return schoolInfo;
      },

      prepareInfoSchool(school) {
        return [
          { value: school.school_name },
          { value: school.subject_name },
          { value: school.school_code },
        ];
      },

      deleteSelectedTeacher() {
        this.teacher = {};
      },

      getLastStatus(items) {
        return items[items.length - 1];
      },

    },
    watch: {
      'filters.schoolId': {
        handler(newVal, oldVal) {
          if (newVal) {
            this.fetchTeachers(1);
          } else {
            // reset items when we clean school id
            this.items = [];
            this.totalItems = 0;
            this.pagination.page = 1;
            this.pagination.itemsPerPage = 10;
          }
        },
      },
      'filters.years': {
        handler(newVal, oldVal) {
          // reset items when we clean school id
            this.items = [];
            this.totalItems = 0;
            this.pagination.page = 1;
            this.pagination.itemsPerPage = 10;
            this.fetchTeachers(1);
        },
      },
      'pagination.sortBy': {
        handler(newVal, oldVal) {
          this.refetchOnSortChange(newVal, oldVal);
        },
      },
      'pagination.sortDesc': {
        handler(newVal, oldVal) {
          this.refetchOnSortChange(newVal, oldVal);
        },
      },
    },
  };
</script>
